import { config, library } from '@fortawesome/fontawesome-svg-core'
import {
  faBars,
  faCaretRight,
  faCheckSquare,
  faCoffee,
  faTag,
  faTags,
  faTimes,
  faCaretDown,
  faCaretUp,
  faStar,
  faPhoneVolume,
  faUsers,
  faPlus,
  faMinus,
} from '@fortawesome/free-solid-svg-icons'

import '@fortawesome/fontawesome/styles.css'

config.autoAddCss = false
library.add(
  faCheckSquare,
  faCoffee,
  faTimes,
  faBars,
  faCaretRight,
  faTag,
  faTags,
  faCaretDown,
  faCaretUp,
  faStar,
  faPhoneVolume,
  faUsers,
  faPlus,
  faMinus,
)
